
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Katrajtomumbaicbaservice() {



    const cardData =
    {
        keyword: 'Katraj to Mumbai Cab Service',
        heading: 'Meghana Cab : Katraj to Mumbai Cab Service',
        headingDescription: 'Meghana Cab offers Katraj to Mumbai Cab Service, providing a dependable and comfortable travel experience from Pune’s southern gateway to the city of Mumbai. Whether it’s for business, leisure, or an airport transfer, our fleet of well-maintained Hatchbacks, Sedans, SUVs, Innova Crysta, and Tempo Travellers ensures a smooth ride tailored to your needs. Enjoy door-to-door pickups from Katraj, experienced chauffeurs, transparent pricing, and 24/7 customer support. Book your Katraj to Mumbai Cab with Meghana Cab today and travel with confidence, convenience, and complete peace of mind.',


        top: 'Top Places to Visit in Mumbai with Meghana Cab',

      "topPlaces": [ 
 
  {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as Mumbai’s most enduring symbol, built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, this colossal basalt arch marks the point from which the last British troops left India, making it both a historical and emotional landmark. Located in Apollo Bunder, it serves as a hub for ferry rides to Elephanta Island and provides stunning views at sunrise and sunset. The Indo-Saracenic style architecture and its vibrant surroundings filled with street vendors, photographers, and tourists make it a dynamic cultural hub."
  },
   {
    "title": "Siddhivinayak Temple",
    "description": "One of the richest and most visited temples in Mumbai, Siddhivinayak is dedicated to Lord Ganesha, the remover of obstacles. Originally built in 1801, it features a gold-plated inner sanctum and a unique idol carved from a single black stone, with the trunk curving to the right. The temple draws politicians, Bollywood celebrities, and millions of devotees annually, especially on Tuesdays when the lines stretch for hours. Despite the crowds, the spiritual atmosphere and meticulous organization make it a peaceful yet powerful experience."
  },
  {
    "title": "Marine Drive & Girgaon Chowpatty",
    "description": "Stretching 3.6 kilometers along the Arabian Sea, Marine Drive is Mumbai’s iconic palm-lined promenade shaped like a necklace, earning it the nickname 'Queen’s Necklace.' It’s a favorite spot for joggers, lovers, and tourists who gather to admire the sea view and city skyline, especially at sunset. At the northern end lies Girgaon Chowpatty, a lively beach known for its street food—bhel puri, pav bhaji, gola—and as a venue for the grand Ganesh Visarjan immersions. The entire stretch embodies Mumbai’s coastal spirit and urban pulse."
  },
   {
    "title": "Elephanta Caves",
    "description": "Located 11 km offshore on Elephanta Island, these 5th-to-8th-century rock-cut caves are a UNESCO World Heritage Site showcasing ancient Indian art dedicated primarily to Lord Shiva. The highlight is the massive Trimurti sculpture—depicting the three aspects of Shiva—carved into a single rock face. The island offers not just religious and artistic significance but also scenic views, lush trails, and a tranquil ferry ride from the Gateway of India, making it a full-day cultural and nature getaway from Mumbai's bustle."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "A masterpiece of Victorian Gothic Revival architecture fused with Indian design, CST (formerly Victoria Terminus) is a UNESCO World Heritage Site and one of India’s busiest railway stations. Constructed in 1887, the terminus features turrets, pointed arches, domes, stained-glass windows, and intricate carvings of animals and deities. It stands as a testament to colonial-era craftsmanship while functioning as a modern-day transport lifeline for over 3 million daily commuters. Its majestic façade is especially breathtaking when illuminated at night."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Built in 1431 in honor of the Sufi saint Haji Ali, this Indo-Islamic marble dargah sits on a tiny islet 500 meters off the coast, connected by a narrow causeway that floods during high tide. It is visited by people of all religions and backgrounds, symbolizing Mumbai’s spiritual inclusiveness. With white domes, intricate mirror work, and prayers echoing against sea winds, it offers both a religious and atmospheric experience. The view of the Mumbai skyline from the dargah adds a contemplative beauty to the site."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya (Prince of Wales Museum)",
    "description": "Housed in a grand Indo-Saracenic building amidst lush gardens, this museum features over 50,000 artifacts from ancient to modern India. Its galleries cover art, archaeology, armory, numismatics, and decorative arts, including standout collections of miniature paintings, Buddhist sculptures, Mughal weaponry, and European antiques. The museum offers guided tours, audio guides, and children's workshops, making it both educational and engaging for visitors of all ages. Its architectural grandeur and curated exhibits make it one of India’s finest museums."
  },
  {
    "title": "Colaba Causeway",
    "description": "A vibrant shopping and cultural district near the Gateway of India, Colaba Causeway offers a sensory overload of colors, sounds, and flavors. Street stalls sell everything from junk jewelry and antiques to clothing and souvenirs, while iconic cafés like Leopold and Café Mondegar cater to tourists and locals alike. It’s the perfect place to experience Mumbai’s cosmopolitan vibe, blending colonial architecture with contemporary fashion, street food, and bustling life from early morning until late night."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular coastal stretches, offering a blend of natural beauty, local flavors, and a touch of celebrity culture. Frequented by locals for evening walks, kite flying, and beachside yoga, the beach is also known for its chaat stalls, pony rides, and occasional film shoots. It's common to spot Bollywood stars residing nearby. The beach also hosts cultural festivals and public events, making it more than just a leisure destination—it’s a slice of Mumbai’s identity."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "This 87-square-kilometer green oasis within city limits offers a rare mix of wildlife sanctuary, recreational space, and ancient history. The park houses deer, leopards, monkeys, and over 250 species of birds, along with a toy train, boating lake, and nature trails. The Kanheri Caves within the park—dating from 1st century BCE to 10th century CE—are a group of over 100 Buddhist rock-cut monasteries and prayer halls. The combination of spirituality, wildlife, and open space makes it one of Mumbai’s most unique destinations."
  }
],

    "services": [
    {
      "name": "Katraj to Mumbai Taxi Booking",
      "description": "Book your taxi from Katraj to Mumbai effortlessly with our user-friendly online platform. We offer reliable and comfortable cab services tailored to your schedule, ensuring a smooth journey every time."
    },
    {
      "name": "One Way Cab Katraj to Mumbai",
      "description": "Choose our one-way cab service from Katraj to Mumbai for direct, hassle-free travel. Perfect for airport transfers, business trips, or personal visits with transparent pricing and no return obligation."
    },
    {
      "name": "Round Trip Katraj to Mumbai Cab",
      "description": "Opt for a round-trip cab service between Katraj and Mumbai for added convenience. Our chauffeurs wait for your return journey, offering seamless travel and excellent customer service both ways."
    },
    {
      "name": "Online Booking Katraj to Mumbai Cab",
      "description": "Experience quick and secure online booking for cabs from Katraj to Mumbai. Enjoy instant confirmation, flexible payment options, and real-time ride tracking for a stress-free travel experience."
    },
    {
      "name": "Budget Travel Cab Katraj to Mumbai",
      "description": "Travel economically from Katraj to Mumbai with our budget-friendly cab service. Our well-maintained vehicles provide a safe and comfortable ride without stretching your budget."
    },
    {
      "name": "AC Cab Katraj to Mumbai",
      "description": "Beat the heat with our air-conditioned cab service from Katraj to Mumbai. Ideal for longer journeys, our AC cabs guarantee a refreshing and relaxing ride for individuals and families alike."
    },
    {
      "name": "SUV Taxi Katraj to Mumbai",
      "description": "Our spacious SUV taxis from Katraj to Mumbai are perfect for group travel or families needing extra luggage space. Travel comfortably on highways with ample room and powerful vehicles."
    },
    {
      "name": "Sedan Hire Katraj to Mumbai",
      "description": "Hire a comfortable and stylish sedan cab from Katraj to Mumbai. Perfect for solo travelers, couples, or business professionals who prefer a smooth, efficient ride with a touch of elegance."
    },
    {
      "name": "Chauffeur Driven Cab Katraj to Mumbai",
      "description": "Enjoy a premium travel experience with our chauffeur-driven cab service from Katraj to Mumbai. Our professional drivers ensure timely pickups, safe driving, and courteous service throughout your journey."
    },
    {
      "name": "Private Taxi Katraj to Mumbai",
      "description": "Book a private taxi from Katraj to Mumbai for exclusive and uninterrupted travel. This service offers flexibility, privacy, and comfort for individuals, families, or corporate travelers."
    },
    {
      "name": "Fast Booking Cab Katraj to Mumbai",
      "description": "Need a cab on short notice? Our fast booking service guarantees quick cab allocation from Katraj to Mumbai with minimal waiting time and efficient route management."
    },
    {
      "name": "Group Cab Katraj to Mumbai Trip",
      "description": "Travel with your group comfortably with our group cab services from Katraj to Mumbai. Spacious vehicles, reliable drivers, and convenient scheduling make group travel easy and enjoyable."
    },
    {
      "name": "Family Cab Katraj to Mumbai",
      "description": "Our family-friendly cab services from Katraj to Mumbai focus on safety, space, and comfort, making your family trips relaxed and enjoyable, whether for vacations or special occasions."
    },
    {
      "name": "Reliable Travel Cab Katraj to Mumbai",
      "description": "Count on our reliable travel cab service from Katraj to Mumbai, committed to punctuality, well-maintained vehicles, and courteous drivers to provide a hassle-free travel experience."
    },
    {
      "name": "24/7 Taxi Service Katraj to Mumbai",
      "description": "Avail our round-the-clock taxi services from Katraj to Mumbai for anytime travel needs. Be it early morning flights or late-night returns, we are ready to serve you with prompt pickups and safe rides."
    }
  ],
  "tableData": [
    ["Katraj to Mumbai Taxi Booking", "One Way Cab Katraj to Mumbai"],
    ["Round Trip Katraj to Mumbai Cab", "Online Booking Katraj to Mumbai Cab"],
    ["Budget Travel Cab Katraj to Mumbai", "AC Cab Katraj to Mumbai"],
    ["SUV Taxi Katraj to Mumbai", "Sedan Hire Katraj to Mumbai"],
    ["Chauffeur Driven Cab Katraj to Mumbai", "Private Taxi Katraj to Mumbai"],
    ["Fast Booking Cab Katraj to Mumbai", "Group Cab Katraj to Mumbai Trip"],
    ["Family Cab Katraj to Mumbai", "Reliable Travel Cab Katraj to Mumbai"],
    ["24/7 Taxi Service Katraj to Mumbai", ""]
  ],




"whychoose": [
    {
        "WhyChooseheading": "Reliable Katraj to Mumbai Cab Service for Comfortable Travel",
        "WhyChoosedescription": "Our cab service from Katraj to Mumbai ensures prompt pickups and smooth, hassle-free journeys. Whether you’re traveling for business, airport transfers, or leisure, we prioritize your comfort and timely arrival to your destination."
    },
    {
        "WhyChooseheading": "Clean, Spacious, and Well-Maintained Vehicles",
        "WhyChoosedescription": "Ride in air-conditioned, thoroughly cleaned, and well-serviced cars. Our fleet is regularly maintained to provide you with a comfortable, safe, and pleasant travel experience, no matter the distance."
    },
    {
        "WhyChooseheading": "Experienced and Courteous Drivers",
        "WhyChoosedescription": "Our professional drivers are trained, background-verified, and familiar with the best routes from Katraj to Mumbai. They ensure safe driving practices, punctuality, and a friendly travel experience, making your journey stress-free."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "We offer upfront and competitive pricing that includes fuel, tolls, taxes, and driver allowances. Our transparent pricing policy means you won’t face any unexpected fees, allowing you to travel with peace of mind."
    },
    {
        "WhyChooseheading": "Flexible Booking Options Tailored to Your Needs",
        "WhyChoosedescription": "Whether you require a one-way trip, round trip, or hourly cab rental, we offer customizable booking plans to suit your schedule. Choose your preferred pickup and drop-off locations within Katraj and Mumbai for maximum convenience."
    },
    {
        "WhyChooseheading": "Door-to-Door Pickup and Drop-off Service",
        "WhyChoosedescription": "Enjoy the convenience of our door-to-door service, with pickups and drop-offs at your exact locations in Katraj and Mumbai. This eliminates the need for additional transfers or waiting at common cab stands."
    },
    {
        "WhyChooseheading": "Perfect for Airport Transfers, Corporate Travel, and Family Outings",
        "WhyChoosedescription": "Our cabs cater to all travel needs, including airport transfers, business trips, and family outings. Experience comfortable, reliable, and professional service every time you travel."
    },
    {
        "WhyChooseheading": "24/7 Customer Support and Easy Online Booking",
        "WhyChoosedescription": "Our dedicated customer support team is available around the clock to assist with bookings, cancellations, and special requests. Book your Katraj to Mumbai cab anytime, knowing help is just a call or click away."
    }
]






















    }

const faqData = [
    {
        question: "How can I book a cab from Katraj to Mumbai?",
        answer: "You can book a cab by calling Meghana Cab at +91 9075462128 or by using our website for quick online booking."
    },
    {
        question: "What is the average travel time from Katraj to Mumbai by cab?",
        answer: "The journey typically takes around 3.5 to 4.5 hours depending on traffic and time of departure."
    },
    {
        question: "Are one way and round trip cab options available from Katraj to Mumbai?",
        answer: "Yes, Meghana Cab provides both one way and round trip services to suit your travel needs."
    },
    {
        question: "What types of vehicles are available for this route?",
        answer: "We offer hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers for individual and group travel."
    },
    {
        question: "Is the cab service from Katraj to Mumbai available 24/7?",
        answer: "Yes, our services are available 24/7, including late-night and early-morning travel."
    },
    {
        question: "What’s included in the cab fare for the Katraj to Mumbai route?",
        answer: "The fare includes fuel, tolls, and driver charges. Extra charges may apply for parking or extended waiting time."
    },
    {
        question: "Can I make a last-minute cab booking from Katraj to Mumbai?",
        answer: "Yes, last-minute bookings are accepted based on vehicle availability. Call us directly for quick assistance."
    },
    {
        question: "Is online booking available for this cab service?",
        answer: "Yes, you can book online through our secure website anytime, day or night."
    },
    {
        question: "Can I request rest or meal stops during the journey?",
        answer: "Yes, you can request stops during the journey. Please inform us while booking or coordinate with the driver."
    },
    {
        question: "Are Meghana Cab drivers experienced with the Katraj to Mumbai route?",
        answer: "Yes, all our drivers are trained, licensed, and familiar with the Katraj to Mumbai travel route."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Harshad Gaikwad',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Great experience! The cab from Katraj to Mumbai was on time, clean, and the driver was courteous.”',
    },
    {
        name: 'Ms. Sneha Patil',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Smooth booking experience and a very comfortable ride. I will definitely use Meghana Cab again for my travels.”',
    },
];






























































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Katraj to Mumbai Cab Service",
  "image": "https://www.meghanacabs.com/assets/images/katraj-to-mumbai-cab.jpg",
  "description": "Book reliable and affordable cab service from Katraj to Mumbai with Meghana Cabs. Options include budget, AC, SUV, and sedan taxis for one-way and round trips. Chauffeur-driven and family-friendly rides available. Online booking 24/7.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5213"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1850",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/katraj-to-mumbai-cab-service"
  }
};







    return (
        <div>

<Helmet>
  <title>Katraj to Mumbai Cab Service | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Book reliable and affordable cab service from Katraj to Mumbai with Meghana Cabs. Budget, AC, SUV, and sedan taxis available for one-way and round trips. Chauffeur-driven and family-friendly rides. Online booking 24/7." 
  />
  <meta 
    name="keywords" 
    content="Katraj to Mumbai Taxi Booking, One Way Cab Katraj to Mumbai, Round Trip Katraj to Mumbai Cab, Online Booking Katraj to Mumbai Cab, Budget Travel Cab Katraj to Mumbai, AC Cab Katraj to Mumbai, SUV Taxi Katraj to Mumbai, Sedan Hire Katraj to Mumbai, Chauffeur Driven Cab Katraj to Mumbai, Private Taxi Katraj to Mumbai, Fast Booking Cab Katraj to Mumbai, Group Cab Katraj to Mumbai Trip, Family Cab Katraj to Mumbai, Reliable Travel Cab Katraj to Mumbai, 24/7 Taxi Service Katraj to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/60.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Katrajtomumbaicbaservice;